import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import "../index.scss";
import SearchAndFilter from "./searchAndFilter";
import Orgfeedback from "./sub-feedback/org-admin";
import Partnerfeedback from "./sub-feedback/partner-admin";
import Enduserfeedback from "./sub-feedback/end-user";
import { Spin } from "antd";

export default function Feedback() {
  const [activeKey, setActiveKey] = useState('ORGANIZATION_ADMIN');

  const [loading, setLoading] = useState(true);
  const [FeedbackData, setFeedbackData] = useState();
  const [reload, SetReload] = useState(false)

  const handleReload = () => {
    SetReload(!reload)
  }

  useEffect(() => {
    let tabVal = sessionStorage.getItem("activeKeySubTabFeedback");
    if (tabVal) {
      setActiveKey(tabVal);
    }
  }, []);

  const changeTab = (activeKey) => {
    setActiveKey(activeKey);
    sessionStorage.setItem("activeKeySubTabFeedback", activeKey);
    if (activeKey === "ORGANIZATION_ADMIN") {
      sessionStorage.setItem("feedbackRole", "ORGANIZATION_ADMIN");
    } else if (activeKey === "PARTNER_ADMIN") {
      sessionStorage.setItem("feedbackRole", "PARTNER_ADMIN");
    } else if (activeKey === "END_USER") {
      sessionStorage.setItem("feedbackRole", "END_USER");
    }
  };
  console.log('FeedbackData', FeedbackData);
  return (
    <div className="tabContainer-feedback">
      <SearchAndFilter setFeedbackData={setFeedbackData} activeKey={activeKey} setLoading={setLoading} reload={reload} />
      <Tabs defaultActiveKey="ORGANIZATION_ADMIN" activeKey={activeKey} onChange={changeTab}>
        <Tabs.TabPane tab="Organisation" key={"ORGANIZATION_ADMIN"}>
          {
            loading ? <div className="data-loader">
              <Spin className="data-loader loading-svg" tip="Loading" size="large" />
            </div>
              :
              <Orgfeedback loading={loading} activeKey={activeKey} FeedbackData={FeedbackData || []} reload={handleReload} />
          }
        </Tabs.TabPane>
        <Tabs.TabPane tab="Partner" key={"PARTNER_ADMIN"}>
          {loading ? <div className="data-loader">
            <Spin className="data-loader loading-svg" tip="Loading" size="large" />
          </div>
            :
            <Partnerfeedback loading={loading} FeedbackData={FeedbackData || []} reload={handleReload} />
          }
        </Tabs.TabPane>
        <Tabs.TabPane tab="End User" key={"END_USER"}>
          {loading ? <div className="data-loader">
            <Spin className="data-loader loading-svg" tip="Loading" size="large" />
          </div>
            : <Enduserfeedback loading={loading} FeedbackData={FeedbackData || []} reload={handleReload} />
          }
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}
